// extracted by mini-css-extract-plugin
export var header = "_vu-1";
export var maskBottom = "_vu-6";
export var maskMiddle = "_vu-7";
export var maskTop = "_vu-5";
export var root = "_vu-0";
export var scrollDownButton = "_vu-3";
export var scrollDownButtonHidden = "_vu-4";
export var viewport = "_vu-2";